<template>
  <v-list class="items_list">
    <v-list-item v-for="item in props.items" :key="item.value" class="list_item" @click="takeValue(item)">
      <v-icon>{{ item.icon }}</v-icon>
      <v-tooltip activator="parent" location="end">{{ translate(item.title) }}</v-tooltip>
    </v-list-item>
    <slot></slot>
  </v-list>
</template>

<script lang="ts" setup>
// Framework import
import { ref } from 'vue'

import { useI18n } from 'vue-i18n'

//Types import
import type Item from '@/types/Item'

const { t } = useI18n()

const props = defineProps<{ items: Array<Item> }>()

const emits = defineEmits<{
  (event: 'selectedItemEvent', value: Item): void
}>()

const selectedItem = ref({} as Item)

const takeValue = (value: Item) => {
  selectedItem.value = value
  emits('selectedItemEvent', selectedItem.value)
}

function translate(title: string) {
  return t(title)
}
</script>

<style lang="scss">
.list_item > .v-list-item__overlay {
  margin: 0 0 -2px -2px !important;
  padding: 0 !important;
}

.list_item > .v-list-item__underlay {
  padding: 0 !important;
  margin: 0 !important;
}

.list_item > .v-ripple__container {
  padding: 0 !important;
  margin: 0 !important;
}
.list_item {
  align-items: center;
  justify-content: center;
  display: flex;
  border-radius: 10px;
}
.items_list .v-list-item__content {
  text-align: center;
}
</style>

<style scoped lang="scss">
.items_list {
  width: 56px !important;
}
</style>
